/**
Author - Venkatesh😉
Git - https://github.com/venkatesh1146
**/

import React, {useState, useEffect} from 'react';
import styled from 'styled-components';

import TradingPreferences from './TradingPreferences';
import {getTradingPreferencesSchema, updateTradingPreferences} from 'api';
import {KYC_FIREBASE_EVENTS} from 'constants/kycFirebaseEvents';
import {handleApiError} from 'helpers';
import {logKycFirebaseEvent} from 'utils/logFirebaseEvents';

import {ProgressBar} from 'components/ProgressBar';

export default function TradingPreferencesContainer({kycData, updateStatus}) {
  const [formSchema, setFormSchema] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    fetchSchema();
  }, []);

  const fetchSchema = async () => {
    try {
      setIsLoading(true);
      const response = await getTradingPreferencesSchema();
      setFormSchema(response.data);
    } catch (error) {
      handleApiError(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleFormSubmit = async (data) => {
    try {
      setIsLoading(true);
      const res = await updateTradingPreferences(data);
      if (res.status === 200) {
        logKycFirebaseEvent(kycData?.flow, KYC_FIREBASE_EVENTS.TRADING_SEGMENTS_SELECTED, {
          segmentType: String(data?.segments || '').toLowerCase(),
        });
        updateStatus();
      }
    } catch (error) {
      handleApiError(error);
    } finally {
      setIsLoading(false);
    }
  };

  return isLoading ? (
    <LoaderContainer>
      <ProgressBar
        showShadow={true}
        subheading="Fetching your trading preferences"
        heading="Please wait"
        waitTimeInSec={180}
        stopOnEndTime={true}
        stopOnEndMsg={'Something went wrong. Please try again...'}
      />
    </LoaderContainer>
  ) : (
    <TradingPreferences handleFormSubmit={handleFormSubmit} schema={formSchema} />
  );
}

const LoaderContainer = styled.div`
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
